import { RouterProvider } from 'react-router-dom';
import AntdProvider from '@/providers/AntdProvider';
import routes from './routes/routes';

export default function App() {
  return (
    <AntdProvider>
      <RouterProvider router={routes()} future={{ v7_startTransition: true }} />
    </AntdProvider>
  );
}
